'use client'

import { useEffect } from 'react'

import { StickyContainer, useMultiScrollState, useTab } from '@/shared/lib'
import { Tab } from '@/shared/ui'

import { TABS, TabValue } from '../../lib/tab'

type Props = {
  tabs: { label: string; value: TabValue }[]
}

export const Tabs = ({ tabs }: Props) => {
  const {
    activeTab,
    setActiveTab,
    getSectionTop,
    updateSections,
    handleScroll,
  } = useTab<typeof TabValue>({
    defaultValue: TabValue.ROOM_INFORMATION,
    tabs: TABS,
  })

  const { scroll } = useMultiScrollState()

  const handleTabClick = (tabValue: TabValue) => () => {
    setActiveTab(tabValue)

    const sectionTop = getSectionTop(tabValue)

    // 혹시라도 스크롤 이동 후 이전 섹션 탭이 활성화되지 않도록 1px 오프셋 추가
    scroll(tabValue, { top: sectionTop, offset: 1 })
  }

  useEffect(() => {
    updateSections()

    window.addEventListener('resize', updateSections)

    return () => {
      window.removeEventListener('resize', updateSections)
    }
  }, [updateSections])

  useEffect(() => {
    handleScroll()

    window.addEventListener('scroll', handleScroll, { passive: true })

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [handleScroll])

  return (
    <StickyContainer>
      <Tab.List>
        {tabs.map(tab => (
          <Tab.Item
            key={tab.value}
            selected={activeTab === tab.value}
            onClick={handleTabClick(tab.value)}
          >
            {tab.label}
          </Tab.Item>
        ))}
      </Tab.List>
    </StickyContainer>
  )
}
